class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.recomendedProductCards = null;

    // define an observer instance
    this.observer = new IntersectionObserver(onIntersection.bind(this), {
      root: null, // default is the viewport
      threshold: 0.5, // percentage of target's visible area. Triggers "onIntersection"
    });

    function onIntersection(entries, opts) {
      entries.forEach((entry, i) => {
        entry.target.classList.toggle('visible', entry.isIntersecting)
        if (this.recomendedProductCards) {

          const nextButton = this.querySelector('.slider-button[name="next"]')
          const previousButton = this.querySelector('.slider-button[name="previous"]')
          if (entry.isIntersecting && this.recomendedProductCards[0] && previousButton) {
            if (this.recomendedProductCards[0].classList.contains('visible') === true) {
              previousButton.setAttribute('disabled', 'disabled');
            } else {
              previousButton.removeAttribute('disabled');
            }
          }

          if (this.recomendedProductCards[this.recomendedProductCards.length - 1] && nextButton) {
            if (this.recomendedProductCards[this.recomendedProductCards.length - 1].classList.contains('visible')) {
              nextButton.setAttribute('disabled', 'disabled');
            } else {
              nextButton.removeAttribute('disabled');
            }
          }

        }
      });
    }

    this.querySelector('.cart-drawer-body').addEventListener('click', this.click.bind(this));

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // this is run by an item being updated, so we want recomendations based on that
      let productOfInterest;

      if (event.cartData?.items_added?.length) {
        productOfInterest = event.cartData.items_added[0].product_id;
      } else if (event.cartData?.items?.length) {
        productOfInterest = event.cartData.items[0].product_id;
      } else if (event.cartData?.product_id) {
        productOfInterest = event.cartData.product_id;
      }

      if (productOfInterest) {
        this.fetchRecomendedProducts(productOfInterest);
      }
    });
  }

  click(event) {

    if (event.target.tagName === 'BUTTON' && event.target.classList.contains('slider-button')) {
      const stageButton = event.target;
      const scrollDirection = stageButton.getAttribute('name') === 'next' ? 'right' : 'left';

      this.recomendedProductCards = [...this.querySelectorAll('.drawer__recomended_products .card-product-items .card-relish-cart')];
      if (scrollDirection === 'right') {
        this.recomendedProductCards.reverse();
      }

      for (var i = 0; i < this.recomendedProductCards.length; i++) {
        if (this.recomendedProductCards[i + 1].classList.contains('visible') === true) {
          this.recomendedProductCards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

          break;
        }
      }
      // Put back to natural order, as we use it in the observer
      if (scrollDirection === 'right') {
        this.recomendedProductCards.reverse();
      }
    }
  };

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    this.fetchRecomendedProducts();

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  fetchRecomendedProducts(product_id) {
    if (this.classList.contains('is-empty')) {
      return;
    }

    const productRecommendationsSection = this.querySelector('.drawer__recomended_products');
    const productToBasedRecomendationsOn = product_id || productRecommendationsSection.dataset.productId
    if (productToBasedRecomendationsOn === undefined || productToBasedRecomendationsOn === '') {
      return;
    }
    fetch(window.Shopify.routes.root + "recommendations/products?with_vat_relief=true&product_id=" + productToBasedRecomendationsOn + "&limit=6&section_id=cart-product-recommendations&intent=related")
      .then(response => response.text())
      .then((text) => {

        const html = document.createElement('div');
        html.innerHTML = text;

        if (productRecommendationsSection) {
          productRecommendationsSection.innerHTML = html.innerHTML;

          this.querySelectorAll('.drawer__recomended_products .card-product-items .card-relish-cart').forEach((item) => {
            this.observer.observe(item);
          });
          this.recomendedProductCards = [...this.querySelectorAll('.drawer__recomended_products .card-product-items .card-relish-cart')];

          this.querySelector('.cart-drawer-body').addEventListener('click', this.click.bind(this));
        }
      });

  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
